import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';

import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  RequestVorhandeneValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import {
  App,
  isAuslandsrisikoort,
  MultiangebotAdressenValidationResult,
} from '@ps20-frontend/frontend-models';
import { equalAdressen } from '@ps20-frontend/vorschlagsdaten-lib';
import { IAppState } from '../../appState';
import { isStandardVorvertragWithSameAdresseExistant } from './multiangebotVorvertragsAdressenValidator';

export function* provideMultiangebotAdressValidationSaga() {
  yield takeEvery(
    GlobalActions.REQUEST_MULTIANGEBOT_VWG_ADRESS_VALIDATION,
    provideMultiangebotAdressValidation,
  );
}

export function* provideMultiangebotAdressValidation(
  action: GlobalAction<RequestVorhandeneValidationPayload>,
) {
  const actionPayload = action.payload;
  const state: IAppState = yield select();

  const globalPut = GlobalPut.getInstance();
  const vwgError = validateMultiangebotVwgAdressen(state, actionPayload);
  yield call(
    globalPut.put,
    new GlobalActions().provideMultiangebotAdressValidation({
      appId: actionPayload.appId,
      angebotsId: actionPayload.angebotsId,
      validationResult: vwgError,
    }),
  );
}

export const validateMultiangebotVwgAdressen = (
  state: IAppState,
  actionPayload: RequestVorhandeneValidationPayload,
) => {
  const risikoortBereitsVersichert: MultiangebotAdressenValidationResult =
    getRisikoortBereitsVersichert(state, actionPayload)
      ? MultiangebotAdressenValidationResult.RISIKOORT_BEREITS_VERSICHERT
      : null;
  const vorvertragWithRisikoortExists = validateMultiproduktVorproduktAdressen(
    state,
    actionPayload,
  );
  return risikoortBereitsVersichert || vorvertragWithRisikoortExists;
};

export const validateMultiproduktVorproduktAdressen = (
  state: IAppState,
  actionPayload: RequestVorhandeneValidationPayload,
) => {
  const vorvertragWithRisikoortExists: MultiangebotAdressenValidationResult =
    isStandardVorvertragWithSameAdresseExistant(
      actionPayload.appId,
      actionPayload.angebotsId,
      actionPayload.risikoort,
      state,
    )
      ? MultiangebotAdressenValidationResult.VORVERTRAG_WITH_SAME_ADRESS_EXISTS
      : null;
  return vorvertragWithRisikoortExists;
};

export const getRisikoortBereitsVersichert = (
  state: IAppState,
  actionPayload: RequestVorhandeneValidationPayload,
) => {
  if (
    ![App.VWG, App.VWG_V2, App.VHV, App.VHV_V2].includes(actionPayload.appId) ||
    isAuslandsrisikoort(actionPayload.risikoort)
  ) {
    return false;
  }

  return state.warenkorb
    .filter(produkt => produkt.appId === actionPayload.appId)
    .some(produkt => {
      return (
        produkt.angebotsId !== actionPayload.angebotsId &&
        equalAdressen(produkt.versicherterRisikoort, actionPayload.risikoort)
      );
    });
};
